import React from "react";
import HeroSlideshow from "../components/HeroSlideshow";
import Sidebar from "../components/Sidebar";
import { HOME_INTRO, HOME_BENEFITS, SITE } from "../data/content";

export default function Home() {
  return (
    <div>
      <HeroSlideshow />
      <div className="flex flex-col lg:flex-row gap-8 mt-8">
        <Sidebar showHomeButtons sidebarBenefits={HOME_BENEFITS} hoursAndContact />
        <article className="flex-1 nn-content">
          <h1>{HOME_INTRO.title}</h1>
          <p className="nn-italic-tagline -mt-2 mb-6">{HOME_INTRO.subtitle}</p>
          {HOME_INTRO.paragraphs.map((p) => (
            <p key={p.slice(0, 32)}>{p}</p>
          ))}
          <div className="my-6 border-l-4 border-[#8da55f] pl-4 bg-[#f6f8ec] py-3">
            <p className="font-semibold mb-1">{HOME_INTRO.covid.title}</p>
            <p>
              {HOME_INTRO.covid.text}{" "}
              For more information,{" "}
              <a
                href={HOME_INTRO.covid.link}
                target="_blank"
                rel="noreferrer"
                className="nn-link font-semibold"
              >
                {HOME_INTRO.covid.linkLabel}.
              </a>
            </p>
          </div>
          <div className="mt-8 text-sm text-[#7d8e54]">
            <p>
              <strong>Address:</strong> {SITE.address2}, {SITE.address3}
            </p>
            <p>
              <strong>Phone:</strong> {SITE.phone}
            </p>
          </div>
        </article>
      </div>
    </div>
  );
}
